<template>
  <div class='companyUser'>
    <div class="intro-y box lg">
      <div
        class="flex items-center p-5 border-b border-gray-200 dark:border-dark-5"
      >
        <h2 class="font-medium text-base mr-auto">公司成员</h2>
      </div>
      <div 
        v-infinite-scroll="companyOnLoad"
        :infinite-scroll-disabled="busy2"
        :infinite-scroll-distance="20"
        class="demo-infinite-container">
        <div
          v-for="(item,index) in companyList" 
          :key="index"
          class="intro-y user"
          @click="clickHandle(item)"
        >
          <div class="box px-4 py-4 flex items-center zoom-in">
            <img :src="item.imgUrl" alt="">
            <span>{{item.name}}</span>
            <!-- <div class="ml-4 mr-auto">
              
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import infiniteScroll from 'vue-infinite-scroll';
  import {accountList} from '../../../api/workbench.js'

  export default {
    name: "companyUser",
    directives: { infiniteScroll },
    components: {},
    props:['adminFlag'],
    data() {
      return {
        imgList:[
          {img:require('../../../../public/img/login/img1.png')},
          {img:require('../../../../public/img/login/img2.png')},
          {img:require('../../../../public/img/login/img3.png')},
          {img:require('../../../../public/img/login/img4.png')},
          {img:require('../../../../public/img/login/img5.png')},
        ],
        companyList:[],
        accountLoading: false,
        busy2: false,
        page3:0,
      }
    },
    methods: {
      companyOnLoad() {
        this.busy2 = true
        this.accountLoading = true;
        setTimeout(() => {
          this.page3++
          this.accountList(true)
        }, 500)
      },
      accountList(flag){
        let para = {
          page:this.page3,
          perPage:20,
        }
        this.busy2 = true;
        this.accountLoading = true
        accountList(para).then(res => {
          let data = res.data
          if (data.code === '000') {
            if (flag) {
              this.companyList = this.companyList.concat(data.content.list)
              if(data.content.hasNextPage) {
                this.busy2 = false
              }else{
                this.busy2 = true
              }
            } else {
              this.companyList = data.content.list
              this.busy2 = false 
              if (data.content.list.length === 0 || data.content.hasNextPage === false) {
              //若无数据（接口返回list长度为0）或只有一页数据，将busy设置为true，不再执行loadMore
                this.busy2 = true
              }
            }
            if(this.companyList.length){
              let arr = this.companyList 
              for (let i in arr) {
                arr[i].imgUrl = this.imgList[Math.floor(Math.random() * 5)].img
              }
              this.companyList = arr
            }
            
          } else {
            
          }
        }).catch(err => {
          console.log(err);
          this.accountLoading = false
        }).finally(() => {
          this.accountLoading = false
        })
      },
      clickHandle(item){
        if(!this.adminFlag){return;}
        this.$router.push({path:'/workBench/staffAssetList',query:{type:'staff',userId:item.id,name:item.name}})
        
      }
    },
    created() {

    },
  }
</script>
<style scoped>
.demo-infinite-container {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 250px;
}

</style>

<style scoped lang="scss">
  .companyUser {
    width: 100%;
    min-height:260px;
    .user {
      display: inline-block;
      width: 50%;
      img {
        display: inline-block;
        height: 30px;
        width: 30px;
        border-radius: 50%;
        margin-right: 10px;
      }
      span {
        line-height:30px;
      }
    }
  }
</style>
